import * as tslib_1 from "tslib";
import Web3 from 'web3';
import { Injectable } from '@angular/core';
let Web3Service = class Web3Service {
    constructor() {
        this.initWeb3();
    }
    initWeb3() {
        if (!!this.initialized) {
            return this.initialized;
        }
        this.initialized = new Promise((res, reject) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            console.log('initializing Web3...');
            let provider;
            if (window.ethereum) {
                console.log('web3 init: found window.ethereum');
                // provider = window.ethereum;
                provider = Web3.givenProvider;
                this.enableEthereum();
            }
            else if (window.web3) {
                console.log('web3 init: using web3.currentProvider');
                this.instance = window.web3.currentProvider;
            }
            else {
                console.log('web3 init: using localhost');
                this.instance = new Web3(new Web3.providers.HttpProvider('http://localhost:7545'));
            }
            console.log('web3 provider: ', provider);
            this.instance = new Web3(provider);
            console.log('initWeb3:', this.instance);
            res(this.instance);
        }));
        console.log('init web3: promise: ', this.initialized);
        return this.initialized;
    }
    enableEthereum() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                yield window.ethereum.enable();
            }
            catch (error) {
                console.error(error);
            }
        });
    }
};
Web3Service = tslib_1.__decorate([
    Injectable({
        providedIn: 'root'
    })
], Web3Service);
export { Web3Service };
//# sourceMappingURL=web3.service.js.map